export default {
      id: "levelmeter-usage",
      viewBox: "0 0 7.704 17.281",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#levelmeter",
      toString: function () {
        return this.url;
      }
    }